import React from 'react';
import { Area, AreaChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';

const MiniArea = ({ data = [], color = '#1890ff' }) => {
  // Generate sample data if none provided
  const chartData = data.length > 0 ? data : [
    { name: '1', value: 10 },
    { name: '2', value: 15 },
    { name: '3', value: 8 },
    { name: '4', value: 20 },
    { name: '5', value: 12 },
    { name: '6', value: 18 },
    { name: '7', value: 25 }
  ];

  return (
    <ResponsiveContainer width="100%" height={46}>
      <AreaChart data={chartData}>
        <XAxis dataKey="name" hide />
        <YAxis hide />
        <Area
          type="monotone"
          dataKey="value"
          stroke={color}
          fill={color}
          fillOpacity={0.3}
          strokeWidth={2}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default MiniArea;
